import { Brand } from "../Model/Brand";
import { BrandRepository } from "../Repository/BrandRepository";

export interface GetBrandListUseCase {
  invoke: () => Promise<Brand[]>;
}

export class GetBrandsList implements GetBrandListUseCase {
  private brandRepo: BrandRepository;
  constructor(_BrandRepo: BrandRepository) {
    this.brandRepo = _BrandRepo;
  }

  async invoke(){
     
    const getData = await this.brandRepo.getBrandsList();
    return getData;
  }
}